(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/handlers/upload-handlers.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/handlers/upload-handlers.js');
"use strict";


const _ref = svs.isServer ? require('../proxy-handler.es6') : svs.components.lbUtils.apiProxy,
  http = _ref.http;
const featureToggle = svs.isServer ? require('../feature-toggle.es6') : svs.components.lbUtils.apiProxy.featureToggle;
const _ref2 = svs.isServer ? require('../constants.es6') : svs.components.lbUtils.apiProxy.constants,
  FEATURE_TOGGLE = _ref2.FEATURE_TOGGLE;
const noTransformResolver = async _ref3 => {
  let data = _ref3.data;
  return data;
};
const uploadHandlers = [http.post('/aruba/v1/mp/:id/:type', noTransformResolver, {
  config: {
    cloudEndpointTemplate: '/v1/mp/:id/:type',
    preserveQuery: true,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_MEDIA_SOC_CLOUD_API, options)
  }
}), http.post('/aruba/v1/mp/:id/:type/base64', noTransformResolver, {
  config: {
    cloudEndpointTemplate: '/v1/mp/:id/:type/base64',
    preserveQuery: true,
    shouldUseCloud: async options => await featureToggle(FEATURE_TOGGLE.MARKETPLACE_MEDIA_SOC_CLOUD_API, options)
  }
})];
if (svs.isServer) {
  module.exports = uploadHandlers;
} else {
  setGlobal('svs.components.lbUtils.apiProxy.handlers.uploadHandlers', uploadHandlers);
}

 })(window);